import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { IoChevronBackCircleSharp } from "react-icons/io5";
import IconButton from "../../core/Dashboard/AddCourse/CourseForm/IconButton";
import { BsChevronDown } from "react-icons/bs";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";

function VideoDetailsSidebar({ setReviewModal }) {
  const [activeStatus, setActiveStatus] = useState("");
  const [videoBarActive, setVideoBarActive] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const { sectionId, subSectionId } = useParams();

  const {
    courseSectionData,
    courseEntireData,
    completedLectures,
    totalNoOfLectures,
  } = useSelector((state) => state.viewCourse);

  useEffect(() => {
    
    (() => {
      if (!courseSectionData.length) {
        return;
      }

      // finding index of course section
      const currentSectionIndex = courseSectionData.findIndex(
        (data) => data.id === sectionId
      );

      // finding subsection inside the course section
      const currentSubSectionIndex = courseSectionData?.[
        currentSectionIndex
      ]?.subSection.findIndex((data) => data._id === subSectionId);

      // getting active subsection id
      const activeSubSectionId =
        courseSectionData[currentSectionIndex]?.subSection?.[
          currentSubSectionIndex
        ]?._id;
      // "subSection": [
      //     {
      //    Line 32 id is referring to this
      //         "_id": "65c4fc9f0fb83ae12dcb06d5",
      //         "title": "Lecture 1",
      //         "timeDuration": "39.839",
      //         "description": "Lecture 1",
      //         "videoUrl": "https://res.cloudinary.com/dzg7eemfm/video/upload/v1707408542/StudyNotion/igqic6rtsb2lohnbqdxl.webm",
      //         "__v": 0
      //     }
      // ],

      // set current section
      setActiveStatus(courseSectionData?.[currentSectionIndex]?._id);

      // set current subSection
      setVideoBarActive(activeSubSectionId);
    })();
  }, [courseSectionData, courseSectionData, location.pathname]);
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const handleAddReview = () => {
    // console.log("I am inside Add handleAddReview");
    setReviewModal(true);
  };

  return (
    <>
      <div className="px-2">
        {/* for buttons and headings */}
        <div>
          {/* for buttons */}
          <div className="flex items-center justify-center gap-x-2 mt-2">
            <div
              onClick={() => {
                navigate("/dashboard/enrolled-courses");
              }}>
              <IoChevronBackCircleSharp className="text-2xl text-richblack-25"/>
            </div>
            <div>
              <IconButton text="Add Review" customClasses={`bg-yellow-25 text-richblack-900 rounded-md px-2 py-1`} onclick={handleAddReview} />
            </div>
          </div>
          {/* for heading or title */}
          <div className="flex gap-x-2 justify-between p-2 items-center">
            <p className="text-xl text-richblack-25">{courseEntireData?.courseName}</p>
            <p className="text-richblack-50">
              {completedLectures?.length} / {totalNoOfLectures}
            </p>
          </div>
        </div>

        {/* for sections and subSections */}
        <div className="">
          {courseSectionData.map((course, index) => (
            <div onClick={() => setActiveStatus(course?._id)} key={index}>
              {/* section */}

              <div className="flex w-[100%] flex-row justify-between bg-richblack-600 text-richblack-25 px-5 py-4">
                <div className="w-[90%] font-semibold">{course?.sectionName}</div>
                <div className="flex items-center gap-2">
                  {/* <span className="text-[12px] font-medium">
                    Lession {course?.subSection.length}
                  </span> */}
                  <span
                    className={`${
                      activeStatus === course?._id
                        ? "rotate-0"
                        : "rotate-180"
                    } transition-all duration-500`}
                  >
                    <BsChevronDown />
                  </span>
                </div>
              </div>

              {/* subSections */}
              <div>
                {activeStatus === course?._id && (
                  <div>
                    {course.subSection.map((topic, index) => (
                      <div
                        className={`flex gap-5 p-5 ${
                          videoBarActive === topic._id
                            ? "bg-yellow-200 text-richblack-900"
                            : "bg-richblack-900 text-white"
                        }`}
                        key={index}
                        onClick={() => {
                          navigate(
                            `/view-course/${courseEntireData?._id}/section/${course?._id}/sub-section/${topic?._id}`
                          );
                          setVideoBarActive(topic?._id);
                        }}>
                        <input
                          type="checkbox"
                          checked={completedLectures.includes(topic?._id)}
                          onChange={() => {}}
                        />
                        <span className="text-richblack-25">{topic.title}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );

  // return (
  //   <>
  //   <div className="flex h-[calc(100vh-3.5rem)] w-[320px] max-w-[350px] flex-col border-r-[1px] border-r-richblack-700 bg-richblack-800">
  //     <div className="mx-5 flex flex-col items-start justify-between gap-2 gap-y-4 border-b border-richblack-600 py-5 text-lg font-bold text-richblack-25">
  //       {/* buttons and heading */}
  //       <div className="flex w-full items-center justify-between ">
  //         <div
  //             className="flex h-[35px] w-[35px] items-center justify-center rounded-full bg-richblack-100 p-1 text-richblack-700 hover:scale-90"
  //             onClick={() => navigate("/dashboard/enrolled-courses")}>
  //           <IoChevronBackCircleSharp/>
  //           </div>
  //           {/* Button and Add Review */}
  //             <div>
  //               <IconButton
  //                 text={"Add Review"}
  //                 onclick={() => {
  //                   handleAddReview()
  //                 }}
  //                 customClasses={`bg-yellow-25 text-richblack-900 rounded-md px-4 px-2`}
  //               />
  //             </div>
  //           </div>
  //         <div className="flex flex-col">
  //           {/* heading */}
  //           <p>{courseEntireData?.courseName}</p>
  //           <p className="text-sm font-semibold text-richblack-500">
  //             {completedLectures?.length}/{totalNoOfLectures}
  //           </p>
  //         </div>

  //       {/* for sections and subSections */}
  //       <div className="h-[calc(100vh - 5rem)] overflow-y-auto">
  //         {courseSectionData.map((section, index) => {
  //           return (
  //             <div
  //               onclick={() =>
  //                 setActiveStatus(section?._id)
  //               }
  //               className="mt-2 cursor-pointer text-sm text-richblack-5"
  //               key={index}>
  //               {/* section */}
  //               <div className="flex flex-row justify-between bg-richblack-600 px-5 py-4">
  //                 <div className="w-[70%] font-semibold">
  //                   {section?.sectionName}
  //                 </div>
  //                   {/* Course name */}
  //                   <div className="flex items-center gap-3">
  //                   {/* Icon */}
  //                   {/* <div>
  //                     {section._id === activeStatus ? (
  //                       <IoIosArrowUp />
  //                     ) : (
  //                       <IoIosArrowDown />
  //                     )}
  //                   </div> */}
  //                   <span
  //                   className={`${
  //                     activeStatus === section?.sectionName
  //                       ? "rotate-0"
  //                       : "rotate-180"
  //                   } transition-all duration-500`}>
  //                   <BsChevronDown />
  //                 </span>
  //                 </div>
  //               </div>

  //               {/* subSection */}
  //               <div>
  //                 {activeStatus === section?._id && (
  //                   <div className="transition-[height] duration-500 ease-in-out">
  //                     {
  //                       // for section we are creating a subsection
  //                       section?.subSection.map((topic, index) => {
  //                         return (
  //                           <div
  //                             className={`${
  //                               topic._id === videoBarActive
  //                                 ? "bg-yellow-25 text-richblack-900"
  //                                 : "bg-richblack-900 text-richblack-25"
  //                             } flex gap-3  px-5 py-2`}

  //                             onClick={()=>{
  //                               navigate(`/view-course/${courseEntireData?._id}/section/${section?._id}/sub-section/${topic?._id}`);
  //                               setVideoBarActive(topic?._id);
  //                             }}

  //                             key={index}>
  //                             <input
  //                               type="checkbox"
  //                               checked={completedLectures.includes(topic._id)}
  //                               onChange={() => {}}
  //                               name=""
  //                               id=""
  //                             />
  //                             <p className="text-white">{topic.title} hello</p>
  //                           </div>
  //                         );
  //                       })
  //                     }
  //                   </div>
  //                 )}
  //               </div>
  //             </div>
  //           );
  //         })}
  //       </div>
  //     </div>
  //   </div>
  //   </>
  // );
}

export default VideoDetailsSidebar;
// import React, { useEffect, useState } from 'react'
// import { useSelector } from 'react-redux';
// import { useLocation, useNavigate, useParams } from 'react-router-dom';
// import IconButton from "../../common/IconButton";

// const VideoDetailsSidebar = ({setReviewModal}) => {

//     const [activeStatus, setActiveStatus] = useState("");
//     const [videoBarActive, setVideoBarActive] = useState("");
//     const navigate = useNavigate();
//     const location = useLocation();
//     const {sectionId, subSectionId} = useParams();
//     const {
//         courseSectionData,
//         courseEntireData,
//         totalNoOfLectures,
//         completedLectures,
//     } = useSelector((state)=>state.viewCourse);

//     useEffect(()=> {
//         const setActiveFlags = () => {
//             if(!courseSectionData.length)
//                 return;
//             const currentSectionIndex = courseSectionData.findIndex(
//                 (data) => data._id === sectionId
//             )
//             const currentSubSectionIndex = courseSectionData?.[currentSectionIndex]?.subSection.findIndex(
//                 (data) => data._id === subSectionId
//             )
//             const activeSubSectionId = courseSectionData[currentSectionIndex]?.subSection?.[currentSubSectionIndex]?._id;
//             //set current section here
//             setActiveStatus(courseSectionData?.[currentSectionIndex]?._id);
//             //set current sub-section here
//             setVideoBarActive(activeSubSectionId);
//         }
//         setActiveFlags();
//     },[courseSectionData, courseEntireData, location.pathname])

//     const handleAddReview = () => {
//         console.log("I am inside Add handleAddReview")
//         setReviewModal(true);
//     }

//   return (
//     <>
//         <div className='text-white'>
//             {/* for buttons and headings */}
//             <div>
//                 {/* for buttons */}
//                 <div>
//                     <div
//                     onClick={()=> {
//                         navigate("/dashboard/enrolled-courses")
//                     }}
//                     >
//                         Back
//                     </div>

//                     <div>
//                         <IconButton
//                             text="Add Review"
//                             onclick={() => handleAddReview()}
//                         />
//                     </div>

//                 </div>
//                 {/* for heading or title */}
//                 <div>
//                     <p>{courseEntireData?.courseName}</p>
//                     <p>{completedLectures?.length} / {totalNoOfLectures}</p>
//                 </div>
//             </div>

//             {/* for sections and subSections */}
//             <div>
//                 {
//                     courseSectionData.map((course, index)=> (
//                         <div
//                         onClick={() => setActiveStatus(course?._id)}
//                         key={index}
//                         >

//                             {/* section */}

//                             <div>
//                                 <div>
//                                     {course?.sectionName}
//                                 </div>
//                                 {/* HW- add icon here and handle rotate 180 logic */}
//                             </div>

//                             {/* subSections */}
//                             <div>
//                                 {
//                                     activeStatus === course?._id && (
//                                         <div>
//                                             {
//                                                 course.subSection.map((topic, index) => (
//                                                     <div
//                                                     className={`flex gap-5 p-5 ${
//                                                         videoBarActive === topic._id
//                                                         ? "bg-yellow-200 text-richblack-900"
//                                                         : "bg-richblack-900 text-white"
//                                                     }`}
//                                                     key={index}
//                                                     onClick={() => {
//                                                         navigate(
//                                                             `/view-course/${courseEntireData?._id}/section/${course?._id}/sub-section/${topic?._id}`
//                                                         )
//                                                         setVideoBarActive(topic?._id);
//                                                     }}
//                                                     >
//                                                         <input
//                                                         type='checkbox'
//                                                         checked= {completedLectures.includes(topic?._id)}
//                                                         onChange={() => {}}
//                                                         />
//                                                         <span>
//                                                             {topic.title}
//                                                         </span>
//                                                     </div>
//                                                 ))
//                                             }
//                                         </div>
//                                     )
//                                 }
//                             </div>
//                         </div>
//                     ))
//                 }
//             </div>
//         </div>
//     </>
//   )
// }

// export default VideoDetailsSidebar
